<div class="user-listing">
  <div class="scroll-container">
    <div class="overflow-y">
      <ng-container
        *ngFor="
          let user of usersList | async | orderBy : ['firstName', 'lastName'];
          let i = index
        "
      >
        <div
          class="row py-2 my-2 user-row pointer-cursor"
          (click)="openUserProfile(user)"
        >
          <!-- Profile Picture -->
          <div class="col-md-1 col-sm-2 col-lg-1 col-xl-1 col-2 pl-2">
            <app-profile-picture-with-status
              [name]="user?.firstName + ' ' + user.lastName"
              [userData]="user"
              [isDeactivated]="user?.isDeactivated"
              type="userlist"
            >
            </app-profile-picture-with-status>
          </div>
          <div class="heading-padding col-7">
            <div class="col-12 heading">
              <app-with-tooltip [showHelpCursor]="true">
                {{ user?.firstName }} {{ user.lastName }}
              </app-with-tooltip>
            </div>
            <div class="col-12 status mt-2">
              <app-with-tooltip [showHelpCursor]="true">
                {{ user?.userType }}
              </app-with-tooltip>
            </div>
          </div>

          <!-- Invitation Icon + Chevron Aligned Right -->
          <div class="col-3 d-flex justify-content-end align-items-center pr-3">
            <img
              *ngIf="user?.invitationPending === 'true'"
              src="assets/svg/invitation-pending.svg"
              class="invitation-pending-icon mr-2"
              alt="Invitation Pending"
              title="Invitation Pending"
              style="width: 20px; height: 20px"
            />
            <img
              src="assets/svg/ico-chevron-forward-outline.svg"
              class="chevron-icon"
              alt="View Profile"
            />
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="row py-3">
    <div class="col-md-1 col-sm-2 col-lg-1 col-xl-1 col-2 pl-2">
      <img
        alt="User Icon"
        src="assets/svg/ico-user-circle.svg"
        class="height-40 width-40"
      />
    </div>
    <div class="heading-padding col-7 add-lock-heading pt-2 mt-1">
      {{ "USER_ADD_USER" | translate }}
    </div>
    <div class="col-3 d-flex justify-content-end align-items-center pr-3 pointer-cursor">
      <img src="assets/svg/ico-add.svg" (click)="addUser()" />
    </div>
  </div>
</div>
